import React, { useState, useEffect } from "react";
// import "./PrivacyPolicy.css";

const PrivacyPolicy = () => {
  const [darkMode, setDarkMode] = useState(true);

  // 🌗 Toggle Theme
  useEffect(() => {
    document.body.className = darkMode ? "dark-theme" : "light-theme";
  }, [darkMode]);

  return (
    <div className="privacy-container">
      {/* 🔹 Header */}
      <header className="privacy-header">
        <img
          src="assets/resources/app-icon/ImageA.png"
          alt="Chess Master Logo"
          className="privacy-logo"
        />
        <h1 className="privacy-title">Privacy Policy</h1>
        <button
          onClick={() => setDarkMode(!darkMode)}
          className="theme-toggle"
          title="Toggle Theme"
        >
          {darkMode ? "☀️ Light" : "🌙 Dark"}
        </button>
      </header>

      {/* 🔹 Main Content */}
      <main className="privacy-content">
        <section>
          <h2>Introduction</h2>
          <p>
            Welcome to <strong>Chess Master</strong>. Your privacy is important
            to us. This Privacy Policy describes how we handle user data in
            accordance with Google Play Developer Policies and global data
            protection standards.
          </p>
        </section>

        <section>
          <h2>Data Collection and Use</h2>
          <p>
            Chess Master does <strong>not collect personal data</strong> unless
            explicitly required for gameplay analytics or user accounts. Any
            optional data you share (like username or match history) is stored
            securely and never shared with third parties without consent.
          </p>
        </section>

        <section>
          <h2>Third-Party Services</h2>
          <p>
            Our app may use trusted services such as <em>Google Play Services</em> or
            analytics tools that comply with user data protection laws. These
            services may collect limited device information to enhance gameplay
            and stability.
          </p>
        </section>

        <section>
          <h2>Advertising</h2>
          <p>
            Chess Master may display <strong>non-intrusive banner or rewarded
            ads</strong>. Ads are shown via compliant ad networks and never
            access sensitive personal information. You will always see the
            “Contains Ads” label on our Play Store listing.
          </p>
        </section>

        <section>
          <h2>Permissions</h2>
          <p>
            The app may request limited permissions (such as internet access) to
            provide online features and multiplayer gameplay. We do not access
            contacts, SMS, or personal files.
          </p>
        </section>

        <section>
          <h2>Children’s Privacy</h2>
          <p>
            For users under 13, Chess Master complies with Google Play’s{" "}
            <strong>Families Policy</strong>. No data is collected or shared
            from child users without verified parental consent.
          </p>
        </section>

        <section>
          <h2>Policy Updates</h2>
          <p>
            Our Privacy Policy may be updated periodically. Any major changes
            will be reflected in-app and on our official website. Continued use
            of the app signifies acceptance of these updates.
          </p>
        </section>

        <section>
          <h2>Contact Us</h2>
          <p>
            If you have any concerns or questions regarding this Privacy Policy,
            contact our support team at{" "}
            <a href="mailto:newrahulgautam@gmail.com">newrahulgautam@gmail.com</a>.
          </p>
        </section>
      </main>

      {/* 🔹 Footer */}
      <footer className="privacy-footer">
        <p>© 2025 Chess Master | All Rights Reserved ♟️</p>
      </footer>
    </div>
  );
};

export default PrivacyPolicy;
